import { useMemo, memo } from 'react';
import cn from 'classnames';
import {
  HeaderWrapper,
  HeaderRow,
  BodyWrapper,
  dataTableStyles,
} from '@creditflowresearch/uilib/Table/DataTable';
import SectorRow from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealBody/Tranches/Sector/SectorRow';
import IndustryRow from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealBody/Tranches/Industry/IndustryRow';
import getSectorColumns from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealBody/Tranches/Sector/SectorColumns';
import getIndustryColumns from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealBody/Tranches/Industry/IndustryColumns';
import { DealType, IDealStatus } from '@/creditflowresearch/domain/vo/IDeal';
import type { IRating } from '@/creditflowresearch/domain/vo/IRating';
import type ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealBody/Tranches/trancheTable.module.scss';

interface ITrancheTableProps {
  dealType: DealType,
  dealStatus: IDealStatus,
  tranches: ITranch[],
  isDealCmbs: boolean,
  ratingsMapping: Record<string, IRating[]>,
}

const TrancheTable = ({
  dealType,
  dealStatus,
  tranches,
  isDealCmbs,
  ratingsMapping,
}: ITrancheTableProps) => {
  const columns = useMemo(
    () => {
      if (dealType === DealType.SECTOR) {
        // @ts-ignore
        return getSectorColumns(isDealCmbs, ratingsMapping);
      }
      if (dealType === DealType.INDUSTRY) {
        return getIndustryColumns(ratingsMapping);
      }

      return undefined;
    },
    [tranches[0].id],
  );

  const RowComponent = useMemo(
    () => (dealType === DealType.SECTOR ? SectorRow : IndustryRow),
    [tranches[0].id],
  );

  return (
    <div className={ styles.tableWrapper }>
      <table
        className={ cn(dataTableStyles.dataTable, dataTableStyles.isStripedOdd) }
        data-test="dealItemTrancheTable"
      >
        <HeaderWrapper>
          <HeaderRow columns={ columns } />
        </HeaderWrapper>
        <BodyWrapper>
          {
            tranches.map((tranche) => (
              <RowComponent
                key={ tranche.id }
                tranche={ tranche }
                isDealCmbs={ isDealCmbs }
                // @ts-ignore
                ratingsMapping={ ratingsMapping }
                dealStatus={ dealStatus }
              />
            ))
          }
        </BodyWrapper>
      </table>
    </div>
  );
};

export default memo(TrancheTable);
